import ToastComponent from '@sdk/common/toast/ToastComponent';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import CreateTimesheet from '@web/timesheets/CreateTimesheet/CreateTimesheet';

const TimesheetViewModalAngular = ({ Authentication, PersonaCollection, onCreateTimesheet }) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <PersonaCollectionContext.Provider value={PersonaCollection}>
          <CreateTimesheet onCreateTimesheet={onCreateTimesheet} />
          <ToastComponent />
        </PersonaCollectionContext.Provider>
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: TimesheetViewModalAngular,
  dependencies: ['Authentication', 'PersonaCollection'],
  bindings: {
    onCreateTimesheet: '&',
  },
};
